import { Listing } from '@tovala/browser-apis-combinedapi'
import { ReactNode } from 'react'

import DetailsDialog from './DetailsDialog'
import { ListingDetails } from './ListingDetails'
import { ListingFull } from 'types/internal'

const ListingDetailsDialog = ({
  onClose,
  listing,
  stepper,
}: {
  onClose(): void
  listing: Listing | ListingFull
  stepper?: ReactNode
}) => {
  return (
    <DetailsDialog onClose={onClose}>
      <ListingDetails listing={listing} stepper={stepper} />
    </DetailsDialog>
  )
}

export default ListingDetailsDialog
